'use client';
import { usePathname } from 'next/navigation';
import Footer from './Footer';

export default function ConditionalFooter() {
  const pathname = usePathname();
  
  // Don't render footer on messages pages
  if (pathname?.includes('/messages')) {
    return null;
  }
  
  return <Footer />;
}
